import React from 'react';

import styles from './logo.module.sass'

import image from '../../../assets/logo.svg'

export const Logo = () => {
    return (
        <div className={styles.main}>
            <div >
                <div className={styles.image}/>
            </div>
        </div>
    );
};

